import { isSensitiveKey, OBSCURED_LITERAL } from './sensitive';

export function obscureSensitiveDataInUrl(this: void, url: string): string {
	const queryStart = url.indexOf('?');

	const hashStart = url.indexOf('#', Math.max(queryStart, 0));
	const beforeHash = hashStart === -1 ? url : url.slice(0, hashStart);
	const fragment = hashStart === -1 ? null : url.slice(hashStart + 1);

	const scrubbedBeforeHash = queryStart === -1
		? beforeHash
		: `${ beforeHash.slice(0, queryStart) }?${ obscureSensitiveParams(beforeHash.slice(queryStart + 1)) }`;

	// Only a fragment carrying values is read as params: a bare `#email` is an anchor.
	const scrubbedHash = fragment === null
		? ''
		: `#${ fragment.includes('=') ? obscureSensitiveParams(fragment) : fragment }`;

	return `${ scrubbedBeforeHash }${ scrubbedHash }`;
}

function obscureSensitiveParams(params: string): string {
	return params
		.split('&')
		.map(pair => {
			if (!pair)
				return pair;

			const equalsIndex = pair.indexOf('=');
			const rawKey = equalsIndex === -1 ? pair : pair.slice(0, equalsIndex);

			let decodedKey: string;

			try {
				decodedKey = decodeURIComponent(rawKey);
			} catch {
				decodedKey = rawKey;
			}

			return isSensitiveKey(decodedKey)
				? `${ rawKey }=${ OBSCURED_LITERAL }`
				: pair;
		})
		.join('&');
}

export function obscureSensitiveDataInJsonString(this: void, json: string): string {
	try {
		return JSON.stringify(JSON.parse(
			json,
			obscureSensitiveDataReplacer,
		));
	} catch {
		return json;
	}
}

export function obscureSensitiveDataReplacer(this: void, key: string, value: unknown): unknown {
	if (isSensitiveKey(key))
		return OBSCURED_LITERAL;

	return value;
}
